// import defaultLang from './lang';
// import store from '@/store/index.js';
//
// // let store = vueStore;
// // Nuxt compatibility workaround
// export function setStore(s) {
//   store = s;
//   // if (!store) store = s;
// }

import allLanguages from '@motionelements/core/src/allLanguages.json';

let defaultLanguageCode = 'en';

export function setLocale(languageCode) {
  defaultLanguageCode = languageCode;
}


/**
 * @param {String} path
 * @param {String=} lang
 */

let baseUrl = 'https://www.motionelements.com';

if (process.env.VUE_APP_ENV !== 'production') {
  switch (true) {
    case process.env.VUE_APP_PRERENDER === 'true':
      // prerender to www
      break;
    // case process.env.VUE_APP_NUXT:
    //   baseUrl = 'https://stage.motionelements.com';
    //   break;
    default:
      baseUrl = 'https://stage.motionelements.com';
      break;
  }
  /*
  if (process.env.VUE_APP_NUXT) {
    baseUrl = process.env.VUE_APP_ENV === 'production' ? 'https://www.motionelements.com' : 'https://stage.motionelements.com';
  } else {
    const isPrerender = process.env.VUE_APP_PRERENDER === 'true';

    // const isPrerender = process.env.VUE_APP_PRERENDER === 'true' || ((typeof navigator !== 'undefined' && navigator.userAgent) || '').indexOf('HeadlessChrome') !== -1;

    if (!isPrerender && process.env.VUE_APP_ENV !== 'production') {
      baseUrl = 'https://stage.motionelements.com';
    }
    // baseUrl = (!isPrerender && process.env.VUE_APP_ENV !== 'production')
    //   ? 'https://stage.motionelements.com'
    //   : 'https://www.motionelements.com';

    if (typeof window !== 'undefined') {
      if (window.location.hostname.indexOf('localhost') === 0) {
        baseUrl = 'https://stage.motionelements.com';
      }
    }

    // debug tool - use when need test 'localhost:8888/*' renderUrl on develop env
    // if (process.env.VUE_APP_ENV === 'development') {
    //   if (window.location.hostname.indexOf('localhost') >= 0) {
    //     baseUrl = window.location.origin;
    //   }
    // }
  }
   */
}

// prevent chromium render return stage.motionelements.com
/*
if (isPrerender) {
  baseUrl = 'https://www.motionelements.com';
} else if (window.location.hostname.indexOf('localhost') === 0) {
  // check if is in route
  // else
  baseUrl = 'https://stage.motionelements.com';
  // baseUrl = window.location.host;
} else if (window.location.hostname === 'stage.motionelements.com') {
  baseUrl = 'https://stage.motionelements.com';
}
 */

// console.log(baseUrl);

const validLanguageCodes = allLanguages.map(({ code }) => code);

// store not ready yet
// let currentLanguageCode;

const link = (path, targetLanguage) => {
  const addQueryParams = {};

  // cache it in constant
  // include zendesk, blog locales
  const localesString = `${validLanguageCodes.join('|')}|en-us|zt|zh-tw|zh`;
  const localesRegex = new RegExp(`^/(${localesString})/`);

  function normalizePathname(pathname) {
    return pathname.replace(localesRegex, '/');
  }

  function toStudioAiLocale(languageCode) {
    switch (languageCode) {
      case 'ja':
      case 'ko':
      case 'zh-hant':
        return languageCode;
      default:
        return '';
    }
  }

  function toBlogLocale(languageCode) {
    switch (languageCode) {
      case 'ja':
      case 'ko':
      case 'zh-hant':
        return languageCode;
      default:
        return '';
    }
  }

  function toFormLocale(languageCode) {
    switch (languageCode) {
      case 'ja':
      case 'ko':
      case 'zh-hant':
        return languageCode;
      default:
        return 'en';
    }
  }

  function toDoc360Locale(languageCode, module) {
    // contributor or contributor/docs
    if (module && module.indexOf('contributor') === 0) {
      switch (languageCode) {
        case 'ja':
        case 'ko':
          // no zh-hant
          return languageCode;
        default:
          return 'en';
      }
    }

    switch (languageCode) {
      case 'ja':
      case 'ko':
      case 'zh-hant':
        return languageCode;
      default:
        return 'en';
    }
  }

  function toArtistHelpCenterLocale(languageCode) {
    switch (languageCode) {
      case 'ja':
      case 'ko':
        return languageCode;
      default:
        return 'en-us';
    }
  }

  function artistToContributor(pathname) {
    return pathname.replace('/artist', '/contributor');
  }

  function renderUrl(path) {
    const languageCode = targetLanguage || defaultLanguageCode;

    let urlPath = path;

    let hasDomain = true;

    if (path.indexOf('/') === 0) {
      urlPath = `${baseUrl}${path}`;
      hasDomain = false;
    } else if (path.indexOf('http://localhost:') === 0) {
      // bug with localhost:xxxx port
      path.replace(/(http:\/\/localhost:[0-9]+)/, baseUrl);
    }

    // https://javascript.info/url
    // need polyfill for IE11
    const url = new URL(urlPath);

    // console.log('URL', url);
    if (Object.keys(addQueryParams).length) {
      Object.entries(addQueryParams).forEach(([k, v]) => {
        url.searchParams.set(k, v);
      });
    }

    let hostname = url.hostname;
    const subdomain = hostname.split('.')[0];

    let pathname = '';
    let module = '';
    let pathParts = [];

    // check for special case sites
    switch (true) {
      case ['help.motionelements.com',
      ].includes(hostname) && url.pathname.indexOf('/contributor/docs/') === 0:
        // module = 'contributor/docs';
        pathParts = url.pathname.replace(/^\/|\/$/g, '').split('/');
        module = `${pathParts[0]}/${pathParts[1]}`;
        pathname = `/${pathParts.slice(2).join('/')}`;
        break;

      case [
        'help.motionelements.com',
          'artists.motionelements.com',
        'artists.zendesk.com',
      ].includes(hostname):
      case url.pathname.indexOf('/blog') === 0:
      case url.pathname.indexOf('/webinars') === 0:
        // remove language
        pathParts = url.pathname.replace(/^\/|\/$/g, '').split('/');
        module = pathParts[0] || '';
        pathname = `/${pathParts.slice(1).join('/')}`;
        break;

      default:
        pathname = url.pathname;
    }

    // remove language
    pathname = normalizePathname(pathname);

    let languagePath;

    let locale = languageCode;

    switch (true) {
      case ['help.motionelements.com'].includes(hostname):
        languagePath = `${toDoc360Locale(languageCode, module)}`;
        return `https://${hostname}/${module}/${languagePath}${pathname.replace(/\/$/, '')}${url.search}${url.hash}`;

      case ['nova.motionelements.com'].includes(hostname):
        if (process.env.VUE_APP_ENV !== 'production') {
          hostname = 'stage-nova.motionelements.com';
        }
        return `https://${hostname}${pathname}${url.search}${url.hash}`;

      case ['form', 'stage-form'].includes(subdomain):
        languagePath = toFormLocale(languageCode);
        return `https://${hostname}/${languagePath}${pathname}${url.search}${url.hash}`;

      case ['ai.motionelements.com'].includes(hostname):
        if (process.env.VUE_APP_ENV !== 'production') {
          hostname = 'stage-ai.motionelements.com';
        }
        locale = toStudioAiLocale(languageCode);
        languagePath = locale ? `/${locale}` : '';
        return `https://${hostname}${languagePath}${pathname}${url.search}${url.hash}`;

      case module === 'blog':
      case module === 'webinars':
        locale = toBlogLocale(languageCode);
        languagePath = locale ? `/${locale}` : '';
        return `https://www.motionelements.com/${module}${languagePath}${pathname}${url.search}${url.hash}`;

        // @deprecated
      case ['go', 'tuts', 'press'].includes(subdomain):
        locale = toBlogLocale(languageCode);
        languagePath = locale ? `/${locale}` : '';
        return `https://${hostname}${languagePath}${pathname}${url.search}${url.hash}`;

      // @deprecated, need to change to help.motionelements.com
      case ['artists.motionelements.com', 'artists.zendesk.com'].includes(hostname):
        languagePath = `/${toArtistHelpCenterLocale(languageCode)}`;
        return `https://${hostname}/${module}${languagePath}${pathname}${url.search}${url.hash}`;

      default:
        languagePath = languageCode !== 'en' ? `/${languageCode}` : '';
    }

    if (hasDomain) {
      const scheme = `${url.protocol}//`;
      return scheme + url.host + languagePath + pathname + url.search + url.hash;
    }

    // check if need to set hostname?
    // if (window.location.hostname.indexOf('localhost') === 0) {
    //   // check if is in route
    //   // else
    //   return baseUrl + languagePath + pathname + url.search + url.hash;
    // }
    if (pathname.includes('/artist')) {
      pathname = artistToContributor(pathname);
    }
    return baseUrl + languagePath + pathname + url.search + url.hash;
  }

  return {
    param(key, value) {
      if (typeof value !== 'undefined' && value !== null) {
        addQueryParams[key] = value;
      }
      return this;
    },
    params(queryParams) {
      if (queryParams) {
        Object.entries(queryParams).forEach(([key, value]) => {
          addQueryParams[key] = value;
        });
      }
      return this;
    },
    fullPath() {
      const finalPath = renderUrl(path);

      // if path is full url
      if (finalPath.indexOf('http') === 0) {
        // convert url to path only
        const url = new URL(finalPath);
        return url.pathname + url.search + url.hash;
      }

      // already is path
      return finalPath;
    },
    url() {
      return renderUrl(path);
    },
    toString() {
      return renderUrl(path);
    },
  };
};

/**
 * site url helper
 *
 * @export
 * @param {String} path
 * @param {String} [languageCode] - lang from store
 * @returns
 */
export default link;
